import { mq, setViewport } from './modules/utils';
import { originalModal } from './modules/modal';
import { originalAccordion } from './modules/accordion';
import { originalAccordionHistory } from './modules/accordion-history';
import { originalTab } from './modules/tab';
import { playersInfoApi } from './modules/players-api';
import { goodsDetail } from './modules/goods-detail';
import { loadingPopUp } from './modules/loading';
import { favoriteRegist } from './modules/favorite';
import { cart } from './modules/cart';
import { anchorLink } from './modules/anchor-link';
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';
window.addEventListener('resize', setViewport);
window.addEventListener('load', setViewport);

const humbMenu = () => {
  const menuToggle = document.querySelector('.menu-toggle');
  const menu = document.querySelector('.menu');
  const menuLinks = document.querySelectorAll('.menu a');
  if (!menuToggle) return;
  // ハンバーガーメニューを開閉
  menuToggle.addEventListener('click', function () {
    const isActive = menu.classList.toggle('active');
    menuToggle.classList.toggle('active');
    document.body.classList.toggle('no-scroll', isActive);
  });
};

// スライドショープラグイン「Splide」
// トップ
const sliderTop = () => {
  const splideEl = document.querySelector('.js-slider-top');
  if (!splideEl) return;
  new Splide(splideEl, {
    type: 'loop',
    autoplay: true,
    interval: 3000,
    pauseOnHover: false,
    rewind: true,
    perPage: 3,
    gap: '6rem',
    focus: 'center',
    arrows: false,
    padding: { left: '14rem', right: '14rem' },
    breakpoints: {
      767: {
        perPage: 1,
        gap: '1rem',
        padding: { left: '5rem', right: '5rem' },
      },
      1700: {
        perPage: 2.5,
        gap: '4rem',
        padding: { left: '10rem', right: '10rem' },
      }
    },
  }).mount();
}
// 商品詳細：スライダー初期化関数
const sliderDetail = () => {
  const splideEl = document.getElementById('image-carousel'); // メインスライダー要素
  const captionEl = document.querySelector('.js-detail-caption'); // キャプション表示用要素

  if (!splideEl) return;

  // メインスライダー設定
  const main = new Splide(splideEl, {
    type: 'fade',
    heightRatio: 1,
    pagination: false,
    arrows: false,
    cover: true,
    padding: { left: '0', right: '0' },
  });

  const thumbnailsEl = document.getElementById('thumbnail-slider'); // サムネイルスライダー要素
  if (!thumbnailsEl) return;

  // サムネイルスライダー設定
  const thumbnails = new Splide(thumbnailsEl, {
    rewind: true,
    gap: 0,
    fixedHeight: 60,
    isNavigation: true,
    pagination: false,
    arrows: false,
    cover: true,
    padding: { left: '0', right: '0' },
    dragMinThreshold: {
      mouse: 4,
      touch: 10,
    },
    breakpoints: {
      767: {
        gap: 5,
        fixedWidth: 60,
        fixedHeight: 60,
        padding: { left: '2rem', right: '2rem' },
      },
    },
  });

  /**
   * キャプションが1つでも存在するか判定する関数
   * @returns {boolean}
   */
  const checkCaptionsExist = () => {
    const slides = splideEl.querySelectorAll('.splide__slide');
    return Array.from(slides).some(slide => slide.dataset.caption?.trim());
  };

  /**
   * キャプションエリアの高さを調整（min-height を設定）
   * @param {boolean} hasCaption - キャプションが存在するかどうか
   */
  const setMinHeightForCaption = (hasCaption) => {
    if (!captionEl) return;

    if (hasCaption) {
      // 一時的にテキストを挿入して高さを測る
      const originalText = captionEl.textContent;
      captionEl.textContent = 'キャプション'; // 高さ測定用の仮テキスト
      const height = captionEl.offsetHeight;
      captionEl.textContent = originalText;

      // 測定した高さを min-height に設定
      captionEl.style.minHeight = `${height}px`;
    } else {
      // キャプションが存在しない場合は最低限の高さに固定（0.1rem → typo 修正）
      captionEl.style.minHeight = '1rem'; // ← 正しい指定（.1rem → 1rem に修正）
      captionEl.textContent = ''; // 表示内容は空にする
    }
  };

  /**
   * 現在表示中のスライドに対応するキャプションを表示する
   */
  const updateCaption = () => {
    if (!captionEl) return;
    const activeSlide = main.Components.Slides.getAt(main.index);
    const caption = activeSlide?.slide?.dataset.caption || '';
    captionEl.textContent = caption;
  };

  // 初期化：Splide準備完了時に実行
  main.on('ready', () => {
    const hasCaption = checkCaptionsExist();
    setMinHeightForCaption(hasCaption);
    updateCaption();
  });

  // スライドが切り替わったときにキャプション更新
  main.on('mounted move', updateCaption);

  // スライダー同士を同期・起動
  main.sync(thumbnails);
  main.mount();
  thumbnails.mount();
};

// 商品詳細：ギャラリープラグイン「Glightbox」
const setupGlightboxWithCounter = (selector = '.glightbox') => {
  const lightbox = GLightbox({ selector });
  const updateCounter = (instance) => {
    const counter = document.querySelector('[data-counter]');
    if (!counter) return;
    const current = (instance.index ?? 0) + 1;
    const total = instance.elements?.length ?? 0;
    counter.textContent = `${current} / ${total}`;
  };
  lightbox.on('open', () => {
    const slider = document.querySelector('.gslider');
    if (!slider) return;
    const counter = document.createElement('p');
    counter.setAttribute('data-counter', '');
    counter.classList.add('gcounter');
    slider.appendChild(counter);
    updateCounter(lightbox);
  });
  lightbox.on('slide_changed', () => updateCounter(lightbox));
  lightbox.on('close', () => {
    const counter = document.querySelector('.gcounter');
    if (counter) counter.remove();
  });
};

// 商品詳細：オプションモーダル内の第2オプションのStickyオフセット値
const setTopFromStickyArea = () => {
  const stickyArea = document.querySelector('.option-block-inner > .top-sticky-area');
  const targetElements = document.querySelectorAll('.js-topPosition');
  if (stickyArea && targetElements.length > 0) {
    const stickyHeight = stickyArea.offsetHeight;
    targetElements.forEach((el) => {
      el.style.top = stickyHeight - 1 + 'px';
    });
  }
};

// 商品詳細：オプションモーダルの選手セレクトがある場合のオプション挙動
const optionInvisible = () => {
  const selectElement = document.querySelector('.player-select select');
  if (!selectElement) return;
  selectElement.addEventListener('change', () => {
    const selectedValue = selectElement.value;
    // すべての対象要素（候補）を非表示にする
    const allTargets = document.querySelectorAll('.invisible');
    allTargets.forEach((el) => {
      el.style.display = 'none';
    });
    // 選択されたIDの要素だけ表示する
    const target = document.getElementById(selectedValue);
    if (target) {
      target.style.display = 'block';
    }
  });
};

// お客様情報入力：クーポン入力エリア追加処理
const couponInputAdd = () => {
  let couponInputCount = 1;
  const plusButton = document.querySelector('.js-plus');
  const couponList = document.querySelector('.coupon-list');

  if (!plusButton) return;

  plusButton.addEventListener('click', (e) => {
    const lastInput = document.getElementById('inputNo' + couponInputCount);
    if (lastInput && lastInput.value === '') {
      return;
    }
    couponInputCount++;
    const newItem = document.createElement('div');
    newItem.className = 'coupon-item';
    newItem.innerHTML = `
    <input type="text" class="tagStyle-input" id="inputNo${couponInputCount}" name="coupon_id[]" placeholder="クーポン番号">
    <div class="coupon-price"></div>
  `;
    couponList.appendChild(newItem);
  });
}
// お客様情報入力：クーポン番号のfetch通信処理
const getCouponAmount = () => {
  const form = document.getElementById('form1');
  if (!form) return;

  const formData = new FormData(form);

  fetch('/action/get_coupon_price_action.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: new URLSearchParams([...formData]),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.result === 'SUCCESS' && data.coupon) {
        const couponPrices = document.querySelectorAll('.coupon-price');
        Object.entries(data.coupon).forEach(([key, val], index) => {
          const priceEl = couponPrices[index];
          if (!priceEl) return;

          if (val === '') {
            priceEl.textContent = '';
          } else {
            priceEl.innerHTML = `&yen;<span class="text-large">${val}</span>割引`;
          }
        });
      }
    })
    .catch((error) => {
      console.error('Error fetching coupon prices:', error);
    });
};
// お客様情報入力：クーポン番号入力の監視
const inputCheckFetch = () => {
  // IME変換中のinput要素を追跡
  const composingInputs = new WeakSet();

  document.addEventListener('compositionstart', (e) => {
    if (!e.target.classList.contains('tagStyle-input')) return;
    composingInputs.add(e.target);
  });

  document.addEventListener('compositionend', (e) => {
    if (!e.target.classList.contains('tagStyle-input')) return;
    composingInputs.delete(e.target);
  });

  document.addEventListener('input', (e) => {
    if (!e.target.classList.contains('tagStyle-input')) return;

    const input = e.target;
    const count = input.value.length;
    const isComposing = composingInputs.has(input);

    // 10文字入力されたら金額取得
    if (count === 10) {
      getCouponAmount();
    }

    // 入力が空なら、最初以外の .coupon-item を削除
    // 【追記】ただしIME変換中は一時的に空になるため削除しない
    if (!isComposing && count < 1) {
      const allItems = document.querySelectorAll('.coupon-list .coupon-item');
      const currentItem = input.closest('.coupon-item');

      if (currentItem && allItems.length > 1 && currentItem !== allItems[0]) {
        currentItem.remove();
      }
    }

    // 10文字未満なら金額表示を消す
    if (count < 10) {
      const priceEl = input.nextElementSibling;
      if (priceEl && priceEl.classList.contains('coupon-price')) {
        priceEl.textContent = '';
      }
    }
  });
}
// お客様情報入力：同意するチェックでボタン活性化
const checkActiveButton = () => {
  const checkbox = document.getElementById('agree');
  const button = document.getElementById('agreeSubmit');

  if(!checkbox) return;

  checkbox.addEventListener('change', function () {
    if (this.checked) {
      button.classList.remove('inactive');
      button.classList.add('primary');
    } else {
      button.classList.remove('primary');
      button.classList.add('inactive');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  originalModal(setTopFromStickyArea);
  originalAccordion();
  if(mq('sp')) {
    originalAccordionHistory();
  }
  originalTab();
  humbMenu();
  loadingPopUp();
  sliderTop();
  sliderDetail();
  setupGlightboxWithCounter();
  optionInvisible();
  playersInfoApi();
  favoriteRegist();
  couponInputAdd();
  inputCheckFetch();
  checkActiveButton();
  anchorLink();
  if (document.querySelector('main.goods_detail')) {
    goodsDetail();
  }
  if (document.querySelector('main.cart') || document.querySelector('main.confirm')) {
    cart();
  }
});
